var $1299194a1aff68b3$exports = {};
$1299194a1aff68b3$exports = {
    "collectionLabel": `Sugest\xf5es`
};


export {$1299194a1aff68b3$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
